import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { Button } from "@/components/ui/button";
import { resetPassword } from "@/api";
import { handleIncompleteRegistration } from "@/lib/handleIncompleteRegistration";
import { PASSWORD_RULES } from "@/lib/passwordRules";
import PasswordField from "@/components/PasswordField";
import ErrorModal from "@/components/ErrorModal";
import { extractApiError } from "@/lib/extractApiError";

const SetPasswordPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const resetToken = searchParams.get("resetToken");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Guard: must have resetToken
  useEffect(() => {
    if (!resetToken) navigate("/");
  }, [resetToken, navigate]);

  const allPassed = PASSWORD_RULES.every((r) => r.test(password));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!allPassed) return;
    setError(null);
    setIsLoading(true);
    try {
      await resetPassword({ consumer: { password } }, resetToken);
      sessionStorage.removeItem("registerData");
      navigate("/");
    } catch (err) {
      const apiError = err.response?.data;
      if (apiError?.data?.error === "error_registration_incomplete") {
        handleIncompleteRegistration(apiError.data.details, navigate);
      } else {
        setError(extractApiError(apiError));
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (!resetToken) return null;

  return (
    <div className="flex flex-col gap-10 items-center w-full max-w-[720px] pt-[80px] pb-[48px] px-5">
      <div className="flex flex-col gap-4 items-center w-full">
        <h1 className="text-black text-center text-[32px] md:text-[40px]">
          Neues Passwort setzen
        </h1>
        <p className="text-black text-center text-[18px] font-medium leading-[1.4]">
          Richte dein neues Passwort ein.
        </p>
      </div>

      <form
        onSubmit={handleSubmit}
        className="flex flex-col gap-6 items-center w-full max-w-[480px]"
      >
        <PasswordField
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <ErrorModal
          open={!!error}
          onClose={() => setError(null)}
          message={error?.message}
          errorCode={error?.errorCode}
        />

        <Button
          type="submit"
          className="w-full md:h-[54px] md:text-[24px] md:rounded-[14px]"
          size="sm"
          variant={allPassed ? "default" : "disabled"}
          disabled={!allPassed || isLoading}
        >
          {isLoading ? "Bitte warte..." : "Passwort speichern"}
        </Button>
      </form>
    </div>
  );
};

export default SetPasswordPage;
